import { Button } from "@chakra-ui/react";
import BaseTemplate from "../../components/BaseTemplate";
import FileDropzone from "./FileDropzone";
import { useCallback, useState } from "react";
import UploadLog from "./UploadLog";

// [Upload] shows or hides the drop box -- there is nothing else to choose. Every file goes to the
// edb_megaloader input folder (the backend's FILE_UPLOAD_DIR/1_input) and the megaloader routes it
// by its rules, so the upload-type dropdown that used to pick one of the legacy EDB_UPLOADER_*
// folders went with the demised edb_uploader (2026-09-16).
function UploadDocument() {
    const [showUpload, setShowUpload] = useState<boolean>(false);

    const [refreshKey, setRefreshKey] = useState(0);
    const onUploaded = useCallback(() => setRefreshKey(k => k + 1), []);

    return (
        <BaseTemplate fitToWindow={true}>
            <BaseTemplate.Header>
                {/* variant="actionBar" sets colour AND size - same control as the document library's [Run] */}
                <Button variant="actionBar" onClick={() => setShowUpload(s => !s)}>
                    Upload
                </Button>
            </BaseTemplate.Header>
            {showUpload && (
                <BaseTemplate.Body fitContent>
                    <FileDropzone onUploaded={onUploaded} />
                </BaseTemplate.Body>
            )}
            <BaseTemplate.Body>
                <UploadLog refreshKey={refreshKey} />
            </BaseTemplate.Body>
        </BaseTemplate>
    )
}

export default UploadDocument;
